import styled, { css } from 'styled-components';

import { Box } from '../Box';

import { ReactComponent as LeftSvg } from '@/assets/icons/arrowleft-icon.svg';
import { ReactComponent as CloseSvg } from '@/assets/icons/close-icon-white.svg';
interface AlertBannerWrapperProps {
  $displayAlertBannerWrapper: boolean;
  $hasCookieAlertBanner?: boolean;
  $isShowFulltext?: boolean;
}

export const AlertBannerWrapper = styled(Box)<AlertBannerWrapperProps>`
  width: 100%;
  background: ${({ theme }) => theme.colors.primaryDark};
  display: ${({ $displayAlertBannerWrapper }) =>
    $displayAlertBannerWrapper ? 'none' : 'block'};
  max-height: 0;
  overflow: hidden;
  &.showBanner {
    max-height: ${({ $isShowFulltext }) => ($isShowFulltext ? '100%' : '46px')};
    transition: max-height 0.3s ease-out;
  }
  transition: max-height 0.3s ease-out;
  @media (min-width: 767px) {
    display: block;
  }
`;

export const InnerWrapper = styled(Box)<{ $isShowFullText: boolean }>`
  &&& {
    width: 100%;
    padding: ${({ theme }) => theme.space.s075}
      ${({ theme }) => theme.space.s250};
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: flex-start;
    text-overflow: unset;
    * {
      color: white;
    }

    ${({ theme }) => css`
      @media (max-width: ${theme.components.header.breakpoint}) {
        padding: ${theme.space.s075} 20px;
      }
    `}
  }
`;

export const TextWrapper = styled(Box)<{
  showReadMore: boolean;
}>`
  &&& {
    position: relative;
    flex: 1;
    display: flex;
    gap: 2px;
    text-overflow: unset;
    font-size: ${({ theme }) => theme.fontSizes.p2};
    justify-content: ${({ showReadMore }) =>
      !showReadMore ? 'center' : 'space-between'};

    p {
      padding: 0;
    }
  }
`;

export const TextInfo = styled(Box)<{
  showReadMore: boolean;
}>`
  overflow: hidden;
  display: -webkit-box;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  -webkit-box-orient: vertical;
  max-height: ${({ showReadMore }) => (showReadMore ? '24px' : 'none')};
  line-height: 24px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  transition: all 0.3s ease-in-out;

  p {
    padding: 0;
    margin: 0;
  }
`;

export const TextInfoInvisible = styled(Box)`
  visibility: hidden;
  white-space: nowrap;
  position: absolute;
`;

export const ReadMore = styled(Box)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.p2};
  margin-bottom: 4px;
`;

export const IconWrapper = styled(Box)`
  cursor: pointer;
`;

export const CloseIcon = styled(CloseSvg)`
  display: block;
  min-width: 20px;
`;
export const LeftIcon = styled(LeftSvg)`
  display: block;
  min-width: 20px;
`;
